import * as React from "react"
import { Slot } from "@radix-ui/react-slot"

import { cn } from "@/lib/utils"
import "./primary-button.css"

const sizeClasses = {
  default: "h-9 px-4 py-2 has-[>svg]:px-3",
  sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
  lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
  xl: "h-13 rounded-md px-8 has-[>svg]:px-6 text-base",
} as const

function PrimaryButton({
  className,
  size = "default",
  asChild = false,
  children,
  ...props
}: React.ComponentProps<"button"> & {
  asChild?: boolean
  size?: keyof typeof sizeClasses
}) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      className={cn(
        "glass-btn-primary inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] text-foreground cursor-pointer",
        // eslint-disable-next-line security/detect-object-injection
        sizeClasses[size],
        className
      )}
      {...props}
    >
      <span className="relative z-3 inline-flex items-center gap-2">{children}</span>
    </Comp>
  )
}

export { PrimaryButton }
